<script>
export default {

}
</script>

<template>
    <ul class="about-footer-menu">
        <BaseLink
            :to="{ name: 'about/privacy' }"
            class="footer-link"
        >
            Privacy Policy
        </BaseLink>
    </ul>
</template>

<style lang="scss" scoped>
@import '@design';

.about-footer-menu {
    display: flex;
    padding: 0;
    margin: 0;
}

.footer-link {
    font-size: 12px;
    text-decoration: none;

    &:hover {
        text-decoration: underline;
    }
}
</style>
